import zod from 'zod';

const PermissionSchema = zod.object({
  id: zod.string().uuid().nonempty(),
});

const FormDataSchema = zod.object({
  name: zod.string().nonempty('Nombre del Tipo de usuario es requerido.'),
  active: zod.boolean().default(true),
  permissions: zod.array(PermissionSchema),
});

export { PermissionSchema, FormDataSchema };
